import type { ScaleLinear, ScaleSymLog, ScaleTime } from 'd3-scale';

import { isDynamic, isStatic } from '../../../types/type-guards.js';
import { transformThresholdIntoIndicator } from '../../../utils/thresholds-to-indicator.js';
import { ThresholdIndicatorData } from '../../threshold-bar/indicators/ThresholdIndicator.js';
import type { SparklineThresholdProps } from '../types/sparkline-thresholds-props.js';

interface SparklineThresholdIndicator {
  id: string;
  indicatorData: ThresholdIndicatorData[];
  color: string;
  strokeOnly: boolean;
}

function getMinMax(y0: number, y1: number): [number, number] {
  return [y0, y1].sort((a, b) => a - b) as [number, number];
}

export function mapToThresholdsIndicators(
  thresholdsProps: SparklineThresholdProps[],
  width: number,
  height: number,
  xScale: ScaleTime<number, number>,
  yScale: ScaleLinear<number, number> | ScaleSymLog<number, number>,
) {
  const thresholdIndicators: SparklineThresholdIndicator[] = [];

  thresholdsProps.forEach((thresholdProps) => {
    const { data, color, strokeOnly } = thresholdProps;
    const indicatorData: ThresholdIndicatorData[] =
      transformThresholdIntoIndicator(data, width, yScale, xScale);
    const showStroke = strokeOnly || isDynamic(data) || isStatic(data);

    const isValueInBounds = indicatorData.some((value) => {
      const [minValue, maxValue] = getMinMax(value.y0, value.y1);

      return (
        (maxValue <= height && maxValue >= 0) ||
        (minValue >= 0 && minValue <= height) ||
        (maxValue > height && minValue < 0)
      );
    });

    if (isValueInBounds) {
      thresholdIndicators.push({
        id: crypto.randomUUID(),
        indicatorData,
        color,
        strokeOnly: showStroke,
      });
    }
  });

  return thresholdIndicators;
}
